<section>
  <div class="background-cover">
    <div class="background-cover-wrapper">
      <div class="background-cover-image" [style]="'background-image: url(' + book.amazonImageUrl + ')'"></div>
    </div>
    <div class="book-cover" [style]="'background-image: url(' + book.amazonImageUrl + ')'"></div>
    <button type="button" (click)="selectBook()" class="select-book" [ngClass]="{ 'selected': selected }">Select @if (selected) {
      <span class="check-icon"><img src="../../../assets/img/ai-toolkit/icon-check.svg" alt=""></span>
    }</button>
  </div>
</section>